@if (isOpen$ | async) {
  <div class="fixed inset-0 z-[120] overflow-hidden bg-black/50 px-4 py-4 backdrop-blur-sm md:px-5 md:py-6">
    <div class="mx-auto flex h-[calc(100dvh-2rem)] min-h-0 items-center justify-center md:h-[calc(100dvh-3rem)]">
      <div
        class="relative flex max-h-full w-full flex-col bg-white shadow-xl dark:bg-gray-900
               transition-colors duration-300 ease-in-out border border-gray-200 dark:border-gray-700
               rounded-2xl overflow-hidden {{ modalSizeClasses }}"
      >
        <!-- Header -->
        <div class="flex justify-between items-center p-4 border-b shrink-0">
          <h2 class="text-xl font-semibold text-gray-900 dark:text-gray-100 truncate">
            {{ config()?.title }}
          </h2>

          @if(config()?.porpierties?.closable){
            <button (click)="close()" class="p-1 hover:bg-gray-200 dark:hover:bg-gray-800 rounded-lg">
              <svg class="w-6 h-6 text-gray-500 dark:text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
              </svg>
            </button>
          }
        </div>

        <!-- Body scrolleable -->
        <div class="modal-body min-h-0 flex-1 overflow-y-auto px-3 py-3">
          <ng-template
            [ngComponentOutlet]="component()"
            [ngComponentOutletInputs]="inputs()"
          ></ng-template>
        </div>
      </div>
    </div>
  </div>
}
